import { ScreenUtil } from '@mathflat/videoplayer'
import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { routeName } from '~/@common/constants'
import { webviewService } from '~/@common/services'
import { nativeEventBus } from '~/@common/services/nativeEventBus'

export const useNativeBackHandler = () => {
  const navigate = useNavigate()

  const memoizedPopState = useCallback(() => navigate(-1), [])

  useEffect(() => {
    // 기존 사용성에 따라 아래의 라우트들에서 뒤로가기 버튼을 누르면 앱이 종료되도록 설정
    const primaryRoute = [
      routeName.login,
      routeName.student.defaultPath,
      routeName.student.challenge,
      routeName.student.generalStudentWorkbookList,
      routeName.student.studentWorksheet,
      routeName.student.lectureList,
      routeName.parent.defaultPath,
      routeName.parent.attendance,
      routeName.parent.report,
      routeName.parent.notice,
    ]

    const isPrimaryRoute = primaryRoute.some((route) => route === location.pathname)

    const leave = isPrimaryRoute ? () => webviewService.closeApp() : memoizedPopState
    // 영상이 overlay 최대화 중이면 뒤로가기는 최대화 해제까지만 — 화면을 떠나면 재생이 끊긴다.
    const handler = () => {
      if (ScreenUtil.exitFullScreen()) return
      leave()
    }

    const unsub = nativeEventBus.subscribe('onBackPressed', handler)

    return unsub
  }, [location.pathname, memoizedPopState])
}
